import { EventEmitter, TemplateRef } from '@angular/core';
import { ProductState } from '../../models/product-state';
import { FacetState } from '../../../facets/models/facet-state';
import { UXPage } from '../../../core/models/ux-page';
import { ThemeConfig, USER_CHOICE } from '../../../core/helpers/theme-config';
import { select, Store } from '@ngrx/store';
import * as preferences from '../../../base/actions/preferences.actions';
import * as fromBase from '../../../base/reducers';
import { CombinedFacets } from '../../../facets/models/facet';
import { mapOrder } from '../../../core/helpers/sorting';
import { FilterToggleEvent, FilterGroup } from '../../../shared/models/filter';
var hasChoice = ThemeConfig.get('catalog', 'view-type') === USER_CHOICE;
var CatalogPageComponent = /** @class */ (function () {
    function CatalogPageComponent(store) {
        this.store = store;
        this.loaded = false;
        this.activeChain = [];
        this.expand = new EventEmitter();
        this.toggleFacet = new EventEmitter();
        this.toggleShowMore = new EventEmitter();
        this.toggleOnlyStock = new EventEmitter();
        this.onDetails = new EventEmitter();
        this.onAddCart = new EventEmitter();
        this.onFavoriteToggle = new EventEmitter();
        this.onTypeSwitched = new EventEmitter();
        this.filterToggled = new EventEmitter();
        this.sortOrderToggled = new EventEmitter();
        this.fullWidthView$ = store
            .pipe(select(fromBase.isFullWidthViewEnabled));
    }
    Object.defineProperty(CatalogPageComponent.prototype, "hasViewTypeChoice", {
        get: function () {
            return this.viewTypeAdjustable;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CatalogPageComponent.prototype, "productsLoading", {
        get: function () {
            return this.productState && this.productState.loading;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CatalogPageComponent.prototype, "products", {
        get: function () {
            return this.productState && this.productState.products;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CatalogPageComponent.prototype, "hasProducts", {
        get: function () {
            return this.productsLoading || !!this.products.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CatalogPageComponent.prototype, "productsExpanding", {
        get: function () {
            return this.productState && this.productState.expanding;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CatalogPageComponent.prototype, "onlyStock", {
        get: function () {
            return this.productState && this.productState.onlyStock;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CatalogPageComponent.prototype, "facetsLoading", {
        get: function () {
            return this.facetState && this.facetState.loading;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CatalogPageComponent.prototype, "facets", {
        get: function () {
            // Re-sort the array based on order in page facetgroups array
            if (this.facetState && this.facetState.groups && this.facetState.groups.length > 0) {
                if (this.page && this.page.facetgroups && this.page.facetgroups.length > 0) {
                    return mapOrder(this.facetState.groups, this.page.facetgroups, 'code');
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CatalogPageComponent.prototype, "openGroups", {
        get: function () {
            return this.facetState && this.facetState.open;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CatalogPageComponent.prototype, "chips", {
        get: function () {
            return this.facetState && this.facetState.chips;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CatalogPageComponent.prototype, "applied", {
        get: function () {
            return this.facetState && this.facetState.applied;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CatalogPageComponent.prototype, "hasPageDecoration", {
        get: function () {
            return this.page &&
                ((!!this.page.banner && !!this.page.banner.img)
                    || !!this.page.blocks.length
                    || !!this.page.introText);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CatalogPageComponent.prototype, "totalProductCount", {
        get: function () {
            return this.productState && this.productState.total;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CatalogPageComponent.prototype, "hasVideos", {
        get: function () {
            if (this.page && this.page.videos && this.page.videos.length) {
                return true;
            }
            return false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CatalogPageComponent.prototype, "videoUrl", {
        get: function () {
            return this.page.videos[0].videoUrl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CatalogPageComponent.prototype, "videoQuery", {
        get: function () {
            return this.page.videos[0].query;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CatalogPageComponent.prototype, "videoAttr", {
        get: function () {
            return this.page.videos[0].attr;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CatalogPageComponent.prototype, "filterGroups", {
        get: function () {
            var settings;
            switch (this.page.code) {
                case 'catalog':
                    settings = this.catalogPageSettings;
                    break;
                case 'search':
                    settings = this.searchPageSettings;
                    break;
                default:
                    settings = this.catalogPageSettings;
            }
            if (settings && settings.showFilters) {
                return settings.showFilters;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CatalogPageComponent.prototype, "hasSortOrders", {
        get: function () {
            return this.catalogSortOrders && this.catalogSortOrders.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    CatalogPageComponent.prototype.expandProducts = function () {
        this.expand.emit();
    };
    CatalogPageComponent.prototype.facetToggled = function (event) {
        this.toggleFacet.emit(event);
    };
    CatalogPageComponent.prototype.showMoreToggled = function (group) {
        this.toggleShowMore.emit(group);
    };
    CatalogPageComponent.prototype.inStockToggled = function () {
        this.toggleOnlyStock.emit();
    };
    CatalogPageComponent.prototype.openDetails = function (product) {
        this.onDetails.emit(product);
    };
    CatalogPageComponent.prototype.toggleFavorite = function (event) {
        this.onFavoriteToggle.emit(event);
    };
    CatalogPageComponent.prototype.addCart = function (event) {
        this.onAddCart.emit(event);
    };
    CatalogPageComponent.prototype.switchType = function (event) {
        this.onTypeSwitched.emit(event);
    };
    CatalogPageComponent.prototype.toggleFullWidthView = function (value) {
        this.store.dispatch(new preferences.SetFullWidthView(value));
    };
    CatalogPageComponent.prototype.toggleFilterList = function () {
        this.showFilterList = !this.showFilterList;
    };
    CatalogPageComponent.prototype.onFilterToggled = function (event) {
        this.filterToggled.emit(event);
    };
    CatalogPageComponent.prototype.onSortOrderSelect = function (event) {
        this.sortOrderToggled.emit(event.target.value);
    };
    return CatalogPageComponent;
}());
export { CatalogPageComponent };
